import React, { useState } from 'react'

import useFeatureConfig, { FeatureNames } from '@hooks/useFeatureConfig'
import useModalVisibilityControls from "@hooks/useModalVisibilityControls"

import { CreateInvestmentProposalModal } from "./Modal"

export const useCreateInvestmentProposal = ({
  tenantSlug, dfmIntegrationSlug, client_id, profile_id, risk_profile_id,
  assets, scenarioPlanType
}) => {
  const feature = useFeatureConfig(FeatureNames.INVESTMENT_PROPOSAL__CREATE)
  const { dfmIntegrationConfig } = feature.getOptions({ dfmIntegrationSlug })
  const isEnabledForAsset = asset => {
    return enabledForAsset(
      feature.isEnabled(), dfmIntegrationConfig, scenarioPlanType, asset
    )
  }

  const modalControls = useModalVisibilityControls()
  const [selectedAsset, setSelectedAsset] = useState(undefined)
  const showCreateInvestmentProposalModal = (asset) => {
    setSelectedAsset(asset)
    modalControls.openModal()
  }
  const modal = selectedAsset !== undefined ? (
    <CreateInvestmentProposalModal
      open={modalControls.modalVisible}
      onClose={modalControls.closeModal}
      assetId={selectedAsset?.id}
      riskProfileId={risk_profile_id}
      dfmIntegration={dfmIntegrationConfig}
      tenantSlug={tenantSlug}
      clientId={client_id}
      wealthManagerId={profile_id}
      assets={assets.filter(isEnabledForAsset)}/>
  ) : null

  return {
    modal,
    showCreateInvestmentProposalModal,
    isEnabledForAsset
  }
}

const enabledForAsset = (enabled, dfmIntegrationConfig, scenarioPlanType, asset) => {
  return (
    enabled &&
    asset.grouping_identifier &&
    scenarioPlanType === 'implemented' &&
    dfmIntegrationConfig.supportedAssetTypes.includes(asset.asset_type)
  )
}
